import themes, { DEFAULT_THEME } from 'themes';
import queryString from 'query-string';
import {
  DEFAULT_PROPERTY,
  THEME_PROPERTY_MAP,
  PROPERTIES
} from 'utils/constants';
import { REWARD_TYPE } from './rewards';

const STORAGE_KEY_THEME_NAME = 'windcreek_booking_theme_name';

export function getTheme(themeName) {
  return themes[themeName];
}

export function getThemeName(location = null) {
  const searchString = location ? location.search : window.location.search;
  const params = queryString.parse(searchString);

  if (params.theme && themes[params.theme]) {
    setThemeNameInStorage(params.theme);
    return params.theme;
  }

  if (isThemeSet()) {
    return getThemeNameFromStorage();
  }

  return DEFAULT_THEME;
}

export function getPreferredProperty(location = null) {
  const searchString = location ? location.search : window.location.search;
  const params = queryString.parse(searchString);
  return params && params.defaultProperty && params.defaultProperty;
}

export function isPreferredPropertyExists(property = '') {
  return PROPERTIES && Object.values(PROPERTIES).includes(property);
}

export function getDefaultPropertyForTheme() {
  let themeName = getThemeName();

  /* If preferred property is given and exist in the PROPERTIES list */
  const preferredProperty = getPreferredProperty();
  if (preferredProperty && isPreferredPropertyExists(preferredProperty)) {
    themeName = preferredProperty.toLowerCase();
  }

  return THEME_PROPERTY_MAP[themeName] || DEFAULT_PROPERTY;
}

export function getRewardTitle(type) {
  const rewardTitleMap = {
    [REWARD_TYPE.BONUS_POINTS]: 'Bonus Points',
    [REWARD_TYPE.FOOD_CREDIT]: 'Food Credit',
    [REWARD_TYPE.FREE_PLAY]: 'Free Play',
    [REWARD_TYPE.SHOPPING_DOLLARS]: 'Shopping Dollars',
    [REWARD_TYPE.HOTEL_STAY]: 'Hotel Stay',
    [REWARD_TYPE.WSTORE_EARLY_ACCESS]: 'WStore Early Access',
    [REWARD_TYPE.DRAWING_TICKET]: 'Drawing Ticket',
    [REWARD_TYPE.WSCORE]: 'WScore',
    [REWARD_TYPE.OF_NO_ACTION]: 'OF - No Action',
    [REWARD_TYPE.DEFAULT]: 'Reward'
  };

  return rewardTitleMap[type] || rewardTitleMap[REWARD_TYPE.DEFAULT];
}

// Convert an ISO9075 MySQL DateTime string to a JS Date object.
export function fromIso9075DateString(value) {
  if (!value || typeof value !== 'string') {
    return value;
  } else {
    return new Date(
      value
        .trim()
        .replace(/\//g, '-')
        .replace(' ', 'T') + 'Z'
    );
  }
}

function isThemeSet() {
  return !!getThemeNameFromStorage();
}

function setThemeNameInStorage(themeName) {
  if (themes[themeName]) {
    localStorage.setItem(STORAGE_KEY_THEME_NAME, themeName);

    return true;
  }

  return false;
}

function getThemeNameFromStorage() {
  return localStorage.getItem(STORAGE_KEY_THEME_NAME);
}
